var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',[_vm._v("保障无效，请联系业务人员协助处理。")]),_vm._v(" "),(_vm.info.name)?_c('h3',[_vm._v("业务专员："+_vm._s(_vm.info.name))]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("咨询电话："+_vm._s(_vm.info.phone))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae333b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/components/pay/Error.vue
// module id = null
// module chunks = 